import { useSelector, useDispatch } from 'react-redux';
import { store } from './react-initialize.js';

export default function createSharedStateHook(name, initialValue = null) {
   const actionName = 'set' + name;
   store.injectReducer(name, (state = initialValue, action) => {
      if (action.type === actionName) {
         return action.value;
      } else {
         return state;
      }
   });

   const setter = value => store.dispatch({ type: actionName, value: value });
   const hookReturn = () => [useSelector(state => state[name]), setter];

   // Exposed as a property so this can be mutated outside of react
   hookReturn.set = setter;
   return hookReturn;
}
